const APP_PACKAGE_PICKER_BASE_URL = 'https://www.wix.com/apps/upgrade/';
const PARAM_META_SITE_ID = 'metaSiteId';
const PARAM_PP_ORIGIN = 'pp_origin';
const PARAM_RENDER_IN_MODAL = 'render_in_modal';
const PP_ORIGIN_VALUE = 'app_market_app_page';

export function getAppPackagePickerUrl({
  appId,
  metaSiteId,
  isModalEnabled,
}: {
  appId: string;
  metaSiteId: string;
  isModalEnabled: boolean;
}) {
  const appPackagePickerUrl = new URL(`${APP_PACKAGE_PICKER_BASE_URL}${appId}`);
  appPackagePickerUrl.searchParams.set(PARAM_META_SITE_ID, metaSiteId);
  appPackagePickerUrl.searchParams.set(PARAM_PP_ORIGIN, PP_ORIGIN_VALUE);
  if (isModalEnabled) {
    appPackagePickerUrl.searchParams.set(PARAM_RENDER_IN_MODAL, 'true');
  }
  return appPackagePickerUrl.toString();
}
